import { render, staticRenderFns } from "./MILIDIcons.vue?vue&type=template&id=5112f464&scoped=true&"
import script from "./MILIDIcons.vue?vue&type=script&lang=ts&"
export * from "./MILIDIcons.vue?vue&type=script&lang=ts&"
import style0 from "./MILIDIcons.vue?vue&type=style&index=0&id=5112f464&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112f464",
  null
  
)

export default component.exports